// import React, { useState } from 'react';
// import { Target, Zap } from 'lucide-react';

// const RouteScannerCTA = ({ onNavigate }) => {
//   const [isHovered, setIsHovered] = useState(false);

//   const handleClick = () => {
//     if (onNavigate) {
//       onNavigate();
//     } else {
//       window.location.href = '/route-scanner';
//     }
//   };

//   return (
//     <div className="flex justify-center my-12 md:my-16">
//       <button
//         onClick={handleClick}
//         onMouseEnter={() => setIsHovered(true)}
//         onMouseLeave={() => setIsHovered(false)}
//         className="group relative overflow-hidden bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-600 hover:from-pink-600 hover:via-purple-600 hover:to-blue-600 text-white font-bold py-4 px-8 rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
//       >
//         {/* רקע זוהר */}
//         <div className="absolute -inset-0.5 bg-gradient-to-r from-purple-600 via-pink-500 to-blue-600 rounded-2xl blur opacity-30 group-hover:opacity-60 animate-pulse -z-10"></div>
        
//         {/* גל נע */}
//         <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent transform -skew-x-12 group-hover:translate-x-full transition-transform duration-1000 opacity-10"></div>

//         {/* תוכן */}
//         <div className="relative flex items-center gap-3">
//           <Target className={`w-6 h-6 transition-transform duration-300 ${
//             isHovered ? 'rotate-180 scale-110' : ''
//           }`} />
          
//           <div className="text-center">
//             <div className="text-lg font-bold">🎯 סורק המסלולים החכם</div>
//             <div className="text-sm opacity-90">מצא את המסלול המושלם בשניות</div>
//           </div>
          
//           <Zap className={`w-6 h-6 transition-transform duration-300 ${
//             isHovered ? 'scale-125 rotate-12' : ''
//           }`} />
//         </div>

//         {/* כוכבים מרצדים */}
//         <div className="absolute top-1 right-2 text-yellow-300 animate-pulse">
//           ✨
//         </div>
//         <div className="absolute bottom-1 left-2 text-yellow-300 animate-pulse delay-500">
//           ⚡
//         </div>
//       </button>
//     </div>
//   );
// };

// export default RouteScannerCTA;

import React, { useState } from 'react';

const RouteScannerCTA = ({ onNavigate }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (onNavigate) {
      onNavigate();
    } else {
      window.location.href = '/route-scanner';
    }
  };

  return (
    <div className="flex justify-center my-12 md:my-16">
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transform hover:scale-105 active:scale-95 transition-all duration-300 max-w-xs md:max-w-md cursor-pointer"
      >
        {/* ה-GIF */}
        <img 
          src="/routeScanner.gif" 
          alt="סורק המסלולים החכם" 
          className={`w-full h-auto rounded-xl transition-all duration-300 ${
            isHovered ? 'brightness-110' : ''
          }`}
        />
        
        {/* שכבת hover עדינה */}
        <div className={`absolute inset-0 bg-blue-500/10 rounded-xl transition-opacity duration-300 ${
          isHovered ? 'opacity-100' : 'opacity-0'
        }`}></div>
      </button>
    </div>
  );
};

export default RouteScannerCTA;